const HEX_COLOR = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

const DEFAULT_HEADING_COLOR = "#ff4500";

// A pale wash of the brand colour for the page background (per the Lovable design) —
// mostly white with a touch of the brand colour, never the full-strength colour itself.
const PAGE_TINT_STRENGTH = 0.12;

const hexToRgb = (hex) => {
  let digits = hex.slice(1);
  if (digits.length === 3) {
    digits = digits
      .split("")
      .map((c) => c + c)
      .join("");
  }
  return [0, 2, 4].map((start) => parseInt(digits.substr(start, 2), 16));
};

// WCAG relative luminance of a #rgb / #rrggbb colour.
const relativeLuminance = (hex) => {
  const [r, g, b] = hexToRgb(hex);
  const channel = (v8) => {
    const v = v8 / 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
};

// Mixes the colour toward white by (1 - strength); strength 1 returns the colour unchanged.
const tintTowardWhite = (hex, strength) => {
  const [r, g, b] = hexToRgb(hex);
  const mix = (c) => Math.round(c * strength + 255 * (1 - strength));
  return "rgb(" + mix(r) + ", " + mix(g) + ", " + mix(b) + ")";
};

// Shared by RegistrationForm (heading + submit button) and EmployeeNumberEntry (page
// background) so the two stay in lockstep on a single org's brand colour.
export const getBrandStyle = (brandColor) => {
  if (typeof brandColor !== "string" || !HEX_COLOR.test(brandColor)) {
    return { brandClass: "", brandStyle: {} };
  }
  const luminance = relativeLuminance(brandColor);
  const brandStyle = {
    "--bwai-reg-brand": brandColor,
    // Button text: black or white, whichever reads better.
    "--bwai-reg-brand-text": luminance > 0.179 ? "#000000" : "#ffffff",
    // Heading: brand colour only when it keeps 3:1 contrast on the white card; a pale
    // brand colour falls back to the default.
    "--bwai-reg-heading": luminance <= 0.3 ? brandColor : DEFAULT_HEADING_COLOR,
    "--bwai-reg-page-bg": tintTowardWhite(brandColor, PAGE_TINT_STRENGTH),
  };
  return { brandClass: "bwai-reg-branded", brandStyle: brandStyle };
};

export { HEX_COLOR };
